import { decode } from '@msgpack/msgpack/dist.umd/msgpack.min.js';
import $ from 'jquery';

const W = window;
const LS = W.localStorage;
const PREFIX = 'public';

if (!Symbol.dispose) {
  Object.defineProperty(Symbol, 'dispose', {
    value: Symbol('dispose'),
    writable: false,
    enumerable: false,
    configurable: false,
  });
}

/* prettier-disable */
$.unpack = str =>
  str
    ? decode(
        W.atob(str)
          .split('')
          .map(c => c.charCodeAt(0)),
      )
    : {};

$.storage = {
  remove: name => {
    LS.removeItem(`${PREFIX}:${W.AUTH.authenticated ? `${W.AUTH.user.id}:` : ''}${name}`);
    return $.storage;
  },

  get: (name, def) => {
    let value = LS.getItem(`${PREFIX}:${W.AUTH.authenticated ? `${W.AUTH.user.id}:` : ''}${name}`);
    if (value) value = JSON.parse(value);
    return value || def;
  },

  set: (name, value) => {
    LS.setItem(`${PREFIX}:${W.AUTH.authenticated ? `${W.AUTH.user.id}:` : ''}${name}`, JSON.stringify(value));
    return $.storage;
  },
};
